export default {
  common: {
    inputIntegerTip: 'Please enter a positive integer'
  },
  company: {
    companySetting: 'Enterprise configuration',
    userCount: 'Number of personnel',
    expirationDate: 'Account validity',
    confirmedAccount: 'Confirm account ',
    confirmedAccountTip: 'Are you sure to enable the current account?'
  },
  licensePlate: {
    successTotal: 'Success Total'
  },
  email: {
    details: 'Email Details',
    server: 'Emails Sending Server',
    port: 'Port',
    account: 'Email Account',
    password: 'PassWord',
    sendername: 'Sender Name',
    sender: 'Sender',
    recipient: 'Recipient',
    subject: 'Subject',
    sendTime: 'sendTime',
    status: 'Status',
    emailsExpiryTip: 'Configure account expiration reminder',
    cronVal: 'Mail sending frequency (days)',
    testConnection: 'Test connection',
    save: 'Save',
    threshold: 'Distance to account validity (days)',
    failReason: 'Failure reason',
    content: 'Message content'
  },
  inspection: {
    sn: 'Sn',
    exceptionType: 'Exception Type',
    timesTip: 'Usage times of alcohol tester (remaining/upper limit)',
    daysTip: 'Days of use of alcohol tester (remaining/upper limit)',
    memory: 'Memory (available/total)',
    normal: 'normal',
    exception: 'exception',
    warning: 'warning',
    storage: 'Storage (available/total)',
    inspectionTime: 'Patrol inspection time',
    warningContent: 'Alarm content',
    warningTime: 'Alarm time',
    companyCode: 'company Code',
    name: 'corporate name',
    expiryData: 'Expiration time',
    status: 'status',
    onLine: 'onLine',
    expired: 'Expired for {number} days',
    expiringSoon: 'Expires in {number} days',
    offLine: 'offLine',
    companyNumber: 'Number of Company',
    inspectionTableTitle: 'Equipment patrol warning report',
    companyExpiryTableTitle: 'Enterprise validity report'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/languages/en/v1.js